import { Component, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';

@Component({
  selector: 'app-leaderboard-congrats-popup',
  templateUrl: './leaderboard-congrats-popup.component.html',
  styleUrls: ['./leaderboard-congrats-popup.component.scss'],
})

export class LeaderboardCongratsPopupComponent implements OnInit { 

  constructor(
    private navigator:Navigator,
    private platform:Platform,
  ) { }

  ngOnInit() {
      setTimeout(() => {
        this.navigator.navigateTo('AvatarComponent', { customModalClass: 'custom-modal-class-transparent', backdropDismiss: true })
      }, 3000);
  }

  getImage(){
    if(this.platform.isLandscape()){
      return 'imgs/Leaderboard-Congrats.png'
    }

    if(this.platform.isPortrait()){
      return 'imgs/Leaderboard-Congrats1_portrait.png';
    }
  }


}

